import {
	useEffect,
	useRef,
	useState,
} from 'react';

export const useUserActivity = (inactivityTimeout = 30000) => {
	const [
		isActiveUser,
		setIsActiveUser,
	] = useState(false);
	const [
		isTabActive,
		setIsTabActive,
	] = useState(!document.hidden);

	const inactivityTimerRef = useRef<NodeJS.Timeout | null>(null);

	const resetInactivityTimer = () => {
		setIsActiveUser(true);
		if (inactivityTimerRef.current) {
			clearTimeout(inactivityTimerRef.current);
		}
		inactivityTimerRef.current = setTimeout(() => {
			setIsActiveUser(false);
		}, inactivityTimeout);
	};

	useEffect(() => {
		const handleVisibilityChange = () => {
			setIsTabActive(!document.hidden);

			if (!document.hidden) {
				resetInactivityTimer();
			}
		};

		document.addEventListener('visibilitychange', handleVisibilityChange);

		const events = [
			'mousemove',
			'keydown',
			'touchstart',
			'click',
			'scroll',
			'resize',
			'focus',
			'blur',
		];

		events.forEach((event) => {
			window.addEventListener(event, resetInactivityTimer);
		});

		// Set initial state
		resetInactivityTimer();

		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityChange);
			events.forEach((event) => {
				window.removeEventListener(event, resetInactivityTimer);
			});
			if (inactivityTimerRef.current) {
				clearTimeout(inactivityTimerRef.current);
			}
		};
	}, [
		inactivityTimeout,
	]);

	const consumeActivity = () => setIsActiveUser(false);

	return {
		consumeActivity,
		isActiveUser,
		isTabActive,
	};
};
